<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-con-info comp">
        <el-row class="taxes-box two-cols-form ">
            <el-form
                ref="conInfo"
                :model="conInfo"
                :rules="rules"
                label-width="160px"
                class="acct-form"
                size="small"
                v-on:submit.native.prevent
            >
                <el-col :span="24" class="mes-col">
                    <el-col :span="24">
                        <el-form-item label="客户全称：" class="form-text">
                            <div class="text-con">
                                {{ conInfo.companyname }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="控制人姓名：" prop="custfullname" :class="!lock?'form-text':'required'">
                            <div v-if="!lock" class="text-con">
                                {{ conInfo.custfullname }}
                            </div>
                            <el-input
                                v-else
                                v-model="conInfo.custfullname"
                                placeholder="请输入控制人姓名"
                                :maxlength="64"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件类型：" prop="certificatetype" :class="!lock?'form-text':'required'">
                            <div v-if="!lock" class="text-con">
                                {{ $cache.getDict("130007", conInfo.certificatetype) }}
                            </div>
                            <el-select
                                v-else
                                v-model="conInfo.certificatetype"
                                filterable
                                placeholder="请选择证件类型"
                                v-on:change="$refs.conInfo.validateField('certificateno')"
                            >
                                <el-option
                                    v-for="item in $cache.getDict('130007')"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件号码：" prop="certificateno" :class="!lock?'form-text':'required'">
                            <div v-if="!lock" class="text-con">
                                {{ conInfo.certificateno }}
                            </div>
                            <el-input
                                v-else
                                v-model="conInfo.certificateno"
                                placeholder="请输入证件号码"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="出生日期：" prop="investorsbirthday" :class="!lock?'form-text':'required'">
                            <div v-if="!lock" class="text-con">
                                {{ $util.fmtDate(conInfo.investorsbirthday) }}
                            </div>
                            <date-picker v-else :date="birthSet" v-on:date-get="dateBirth" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税收居民身份：" class="" prop="taxestype">
                            <el-select
                                v-model="conInfo.taxestype"
                                filterable
                                placeholder="请选择税收居民身份"
                                :disabled="oldTax!==''"
                            >
                                <el-option
                                    v-for="item in taxestypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="控制人适用情况：" class="" prop="controllerflag">
                            <el-select
                                v-model="conInfo.controllerflag"
                                filterable
                                placeholder="请选择控制人适用情况"
                            >
                                <el-option
                                    v-for="item in $cache.getDict('120079')"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="控制人类型：" class="" prop="controllertype">
                            <el-select
                                v-model="conInfo.controllertype"
                                filterable
                                placeholder="请选择控制人类型"
                            >
                                <el-option
                                    v-for="item in $cache.getDict('120093')"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-card v-if="taxe" class="box-card">
                    <div slot="header" class="clearfix">
                        <span>控制人出生地址</span>
                    </div>
                    <el-col v-if="taxe" :span="24" class="mes-col">
                        <el-col :span="12">
                            <el-form-item label="国家：" prop="birthcountry" class="required">
                                <el-select v-model="conInfo.birthcountry" filterable placeholder="请选择出生地国家">
                                    <el-option
                                        v-for="item in countrys"
                                        :key="item.subitem"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="省份：" prop="birthprovince">
                                <el-input
                                    v-model="conInfo.birthprovince"
                                    placeholder="请输入出生地省份"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="城市：" prop="birthcity">
                                <el-input
                                    v-model="conInfo.birthcity"
                                    placeholder="请输入出生地城市"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="地址：" prop="birthplace">
                                <el-input
                                    v-model="conInfo.birthplace"
                                    placeholder="请输入出生地地址"
                                    :maxlength="32"
                                />
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-card>
                <el-card v-if="taxe" class="box-card">
                    <div slot="header" class="clearfix">
                        <span>控制人出生地址(英文)</span>
                    </div>
                    <el-col v-if="taxe" :span="24" class="mes-col ">
                        <el-col :span="12">
                            <el-form-item label="国家：" prop="engbirthcountry" class="required">
                                <el-select v-model="conInfo.engbirthcountry" filterable placeholder="请选择出生地国家（英文或拼音）">
                                    <el-option
                                        v-for="item in enCountrys"
                                        :key="item.subitem"
                                        :label="item.subitem + '('+item.subitemname+')'"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="省份：" prop="engbirthprovince" class="required">
                                <el-input
                                    v-model="conInfo.engbirthprovince"
                                    placeholder="请输入出生地省份（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="城市：" prop="engbirthcity" class="required">
                                <el-input
                                    v-model="conInfo.engbirthcity"
                                    placeholder="请输入出生地城市（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="地址：" prop="engbirthplace" class="required">
                                <el-input
                                    v-model="conInfo.engbirthplace"
                                    placeholder="请输入出生地地址（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-card>
                <el-card v-if="taxe" class="box-card">
                    <div slot="header" class="clearfix">
                        <span>控制人现居地址</span>
                    </div>
                    <el-col v-if="taxe" :span="24" class="mes-col">
                        <el-col :span="12">
                            <el-form-item label="国家：" prop="currentcountry" class="required">
                                <el-select v-model="conInfo.currentcountry" filterable placeholder="请选择现居地国家">
                                    <el-option
                                        v-for="item in countrys"
                                        :key="item.subitem"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="地址：" prop="address" :class="{'required':isChina}">
                                <el-input
                                    v-model="conInfo.address"
                                    placeholder="请输入现居地地址"
                                    :maxlength="32"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="邮编：" prop="crspostcode" class="required">
                                <el-input
                                    v-model="conInfo.crspostcode"
                                    placeholder="请输入现居地邮编"
                                    :maxlength="6"
                                />
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-card>
                <el-card v-if="taxe" class="box-card">
                    <div slot="header" class="clearfix">
                        <span>控制人现居地址(英文)</span>
                    </div>
                    <el-col v-if="taxe" :span="24" class="mes-col ">
                        <el-col :span="12">
                            <el-form-item label="国家：" prop="engcurrentcountry" class="required">
                                <el-select v-model="conInfo.engcurrentcountry" filterable placeholder="请选择现居地国家（英文或拼音）">
                                    <el-option
                                        v-for="item in enCountrys"
                                        :key="item.subitem"
                                        :label="item.subitem + '('+item.subitemname+')'"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="省份：" prop="engcurrentprovince" class="required">
                                <el-input
                                    v-model="conInfo.engcurrentprovince"
                                    placeholder="请输入现居地省份（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="城市：" prop="engcurrentcity" class="required">
                                <el-input
                                    v-model="conInfo.engcurrentcity"
                                    placeholder="请输入现居地城市（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="地址：" prop="engaddress" class="required">
                                <el-input
                                    v-model="conInfo.engaddress"
                                    placeholder="请输入现居地地址（英文或拼音）"
                                    :maxlength="64"
                                />
                            </el-form-item>
                        </el-col>
                    </el-col>
                </el-card>
                <el-col v-if="taxe" :span="24" class="mes-col last">
                    <el-col :span="12">
                        <el-form-item label="注册国家代码：" prop="regregioncode">
                            <el-select v-model="conInfo.regregioncode" filterable placeholder="请选择注册国家">
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="注册地址：" prop="regadress">
                            <el-input
                                v-model="conInfo.regadress"
                                placeholder="请输入注册地址"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税收居民国家/地区：" prop="taxesplace" class="required">
                            <el-select v-model="conInfo.taxesplace" filterable placeholder="请选择税收居民国家/地区">
                                <el-option
                                    v-for="item in speCountrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-col :span="12">
                            <el-form-item label="有无纳税人识别号：" prop="tHaveTaxID" class="required">
                                <el-select v-model="conInfo.tHaveTaxID" filterable placeholder="请选择有无居民国家/地区纳税人识别号">
                                    <el-option
                                        v-for="item in tHaveTaxIDs"
                                        :key="item.val"
                                        :label="item.text"
                                        :value="item.val"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col v-if="conInfo.tHaveTaxID==='1'" :span="12">
                        <el-form-item label="纳税人识别号：" prop="taxesno" class="required">
                            <el-input
                                v-model="conInfo.taxesno"
                                placeholder="请输入居民国家/地区纳税人识别号"
                                :maxlength="100"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="conInfo.tHaveTaxID==='0'" :span="12">
                        <el-form-item label="不能提供的原因：" prop="notaxesreason" class="required">
                            <el-select v-model="conInfo.notaxesreason" filterable placeholder="请选择不能提供识别号的原因">
                                <el-option
                                    v-for="item in notaxesreasons"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="conInfo.tHaveTaxID==='0' && conInfo.notaxesreason==='2'" :span="12">
                        <el-form-item label="未能取得的原因：" prop="nogetreason" class="required">
                            <el-input
                                v-model="conInfo.nogetreason"
                                placeholder="请输入未能取得纳税人识别号的原因"
                                :maxlength="128"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model="conInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="" prop="protocol">
                        <el-checkbox-group v-model="conInfo.protocol" class="checkbox-list">
                            <el-checkbox label="1" name="agree">
                                本人确认上述信息的真实、准确和完整性，且当这些信息发生变更时，将在30日内通知贵机构，否则，本人承担由此造成的不利后果。
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button type="yellow" class="medium" v-on:click="submitInfo('conInfo')">
                        确认
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
import format from "date-fns/format";
import datePicker from "@/components/common/datePicker.vue";

export default {
    name: "CrsInfo",
    components: {
        datePicker
    },
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            conInfo: {
                companyname: "",
                certificatetype: "",
                investorsbirthday: "",
                taxestype: "1",
                custfamilyname: "",
                custfirstname: "",
                currentcountry: "",
                currentprovince: "",
                currentcity: "",
                county: "",
                address: "",
                crspostcode: "",
                engcurrentcountry: "",
                engcurrentprovince: "",
                engcurrentcity: "",
                engaddress: "",
                birthcountry: "",
                birthprovince: "",
                birthcity: "",
                birthplace: "",
                engbirthcountry: "",
                engbirthprovince: "",
                engbirthcity: "",
                engbirthplace: "",
                regregioncode: "",
                regadress: "",
                taxesplace: "",
                tHaveTaxID: "",
                taxesno: "",
                notaxesreason: "",
                nogetreason: "",
                protocol: [],
                agreement: "",
                pwd: ""
            },
            checkconInfo: {},
            birthSet: { type: "1", min: "", dis: false , val: "" },
            isPwdCheck: false,
            taxId: "", // 传入修改税收居民信息ID
            lock: "", // 是否是没有税收居民信息新增
            taxe: false, // 是否是中国税收居民
            isChina: false, // 是否是居住地在中国
            oldTax: "", // 原税收军民信息
            taxestypes: [],
            speCountrys: [], // 税收居民国家/地区数据字典
            countrys: [],
            enCountrys: [],
            provinces: [],
            currentcity: [],
            county: [],
            notaxesreasons: [],
            tHaveTaxIDs: [{ val: "0", text: "无" }, { val: "1", text: "有" }],
            taxestypeOld: "",
            rules: {
                certificatetype: [
                    { required: true, message: "请选择证件类型", trigger: "change" }
                ],
                investorsbirthday: [
                    { required: true, message: "请选择出生日期", trigger: "change" }
                ],
                custfullname: [
                    { required: true, message: "请输入控制人姓名", trigger: "blur" }
                ],
                certificateno: [
                    { required: true, message: "请输入证件号码", trigger: "blur" },
                    {validator: this.checkCertNo, trigger: "blur"}
                ],
                // taxestype: [
                //     { required: true, message: "请选择税收居民身份", trigger: "change" }
                // ],
                // controllertype: [
                //     { required: true, message: "请选择控制人类型", trigger: "change" }
                // ],
                // controllerflag: [
                //     { required: true, message: "请选择控制人适用情况", trigger: "change" }
                // ],
                custfamilyname: [
                    { required: true, message: "请输入姓", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                custfirstname: [
                    { required: true, message: "请输入名", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engcurrentprovince: [
                    { required: true, message: "请输入现居省份（英文或拼音）", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                crspostcode: [
                    { required: true, message: "请输入邮政编码", trigger: "blur" },
                    { validator: this.$util.validatePostCode, trigger: "blur" }
                ],
                engcurrentcity: [
                    { required: true, message: "请输入现居城市（英文或拼音）", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engaddress: [
                    { required: true, message: "请输入现居地址（英文或拼音）", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthprovince: [
                    { required: true, message: "请输入出生省份（英文或拼音）", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthcity: [
                    { required: true, message: "请输入出生城市（英文或拼音）", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthplace: [
                    { required: true, message: "请输入出生地址（英文或拼音）", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                address: [
                    { validator: this.validateAddress, trigger: "blur" }
                ],
                nogetreason: [
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                taxesno: [
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                currentcountry: [
                    { required: true, message: "请选择现居地国家/地区", trigger: "change" }
                ],
                currentprovince: [
                    { required: true, message: "请选择现居地省份", trigger: "change" }
                ],
                agreement: [
                    { required: true, message: "请确认上述信息的真实、准确和完整", trigger: "change" }
                ],
                currentcity: [
                    { required: true, message: "请选择现居地城市", trigger: "change" }
                ],
                county: [
                    { required: true, message: "请选择现居地县", trigger: "change" }
                ],
                engcurrentcountry: [
                    { required: true, message: "请选择现居地国家（英文或拼音）", trigger: "change" }
                ],
                birthcountry: [
                    { required: true, message: "请选择出生地国家/地区", trigger: "change" }
                ],
                engbirthcountry: [
                    { required: true, message: "请选择出生地国家/地区（英文或拼音）", trigger: "change" }
                ],
                taxesplace: [
                    { required: true, message: "请选择税收居民国家/地区", trigger: "change" }
                ],
                tHaveTaxID: [
                    { required: true, message: "请选择有无居民国家/地区纳税人识别号", trigger: "change" }
                ],
                notaxesreason: [
                    { required: true, message: "请选择不能提供识别号的原因", trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ],
                protocol: [
                    { required: true, message: "请确认上述信息的真实、准确和完整", trigger: "change" }
                ]
            }
        };
    },
    watch: {
        "conInfo.taxestype" (val) {
            if(val==="1"){
                var keys=["birthcountry", "birthprovince","birthcity","birthplace","engbirthcountry",
                    "engbirthprovince","engbirthcity","engbirthplace","currentcountry","address",
                    "crspostcode","engcurrentcountry","engcurrentprovince","engcurrentcity","engaddress",
                    "regregioncode","regadress","taxesplace","tHaveTaxID","taxesno","notaxesreason","nogetreason"]
                keys.forEach(item=>{
                    this.conInfo[item]=""
                })
            }
            if (val !== "2" && val !== "3") {
                this.taxe = false;
            } else {
                if (this.conInfo.taxesplace === "CN") {
                    this.conInfo.taxesplace = "";
                }
                this.taxe = true;
            }
        },
        "conInfo.currentprovince" (val) {
            if (val !== "") {
                this.getCity(val);
            }
        },
        "conInfo.currentcity" (val) {
            if (val !== "") {
                this.getCounty(val);
            }
        },
        "conInfo.tHaveTaxID" (val) {
            if (val === "0") {
                this.conInfo.taxesno = "";
            } else {
                this.conInfo.notaxesreason = "";
                this.conInfo.nogetreason = "";
            }
        },
        "conInfo.currentcountry" (val) {
            if (val !== "CN") {
                this.isChina = false;
            } else {
                this.isChina = true;
            }
        }
        // "conInfo.protocol" (val) {
        //     if (val.length > 0) {
        //         this.conInfo.agreement = val.join(",");
        //     } else {
        //         this.conInfo.agreement = "";
        //     }
        // }
    },
    created () {
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        this.birthSet.max = this.$util.fmtDate(birthmax);
        this.birthSet.min = this.$util.fmtDate("19000101");
        const conf = this.$util.getConfig().const;
        const info = this.$cache.getUser();
        // 初始化数据字典值
        this.isPwdCheck = this.$cache.getPwdCheck("T3,T4");
        let _x = {

        };
        _x.taxiesinfoid = this.$route.query.taxiesinfoid;
        // if(this.$route.query.conInfo){
        //     this.conInfo = this.$route.query.conInfo;
        //     this.$set(this.birthSet, "val", format(this.conInfo.instreprbirthday,"YYYY-MM-DD"));
        // }
        this.conInfo.taxesflag = this.$route.query.taxesflag;
        this.conInfo.companyname = info.custfullname;
        // this.conInfo.investorsbirthday = info.birthdate;
        // this.conInfo.certificatetype = info.certificatetype;
        // this.conInfo.certificateno = info.certificateno;
        if (this.conInfo.taxesno) {
            this.$set(this.conInfo, "tHaveTaxID", "1");
        } else if (this.conInfo.notaxesreason) {
            this.$set(this.conInfo, "tHaveTaxID", "0");
        }
        this.$set(this.conInfo, "protocol", []);
        this.lock = this.$route.query.lock || "";
        this.oldTax = this.$route.query.tax || "";
        if (!this.lock) {
            this.getconInfo(_x);
        }
        this.checkconInfo = Object.assign({}, this.checkconInfo, this.conInfo);
        this.taxestypes = this.$cache.getDict("120043");
        // if (this.lock) {
        //     this.$set(this.conInfo, "taxestype", this.oldTax);
        //     this.taxestypes = this.taxestypes.filter(item => {
        //         return item.subitem !== "1";
        //     });
        // }
        const _country = this.$cache.getDict("120109");
        let _y = [];
        let _z = [];
        for(let i in _country){
            if(_country[i].subitem === "CN" || _country[i].subitem === "HK" || _country[i].subitem === "MO" || _country[i].subitem === "TW"){
                if(_country[i].subitemname.indexOf("中国") === -1){
                    _country[i].subitemname = "中国" + _country[i].subitemname;
                }
                if(_country[i].subitem === "CN"){
                    _z.unshift(_country[i]);
                }else{
                    _z.push(_country[i]);
                }
                continue;
            }
            _y.push(_country[i]);
        }
        this.countrys = _z.concat(_y);
        this.speCountrys = this.countrys;
        this.enCountrys = this.$cache.getDict("120134");
        this.provinces = this.$cache.getDict("190021");
        this.notaxesreasons = this.$cache.getDict("120044");
    },
    methods: {
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            this.lock&&this.$util.validateCertNo(rule, value, callback, this.conInfo.certificatetype,true);
            let res = this.validateCertNo(value, this.conInfo.certificatetype, [this.birthSet.min,this.birthSet.max], callback);
            // 证件类型选择身份证并且输入身份证号正确
            if (this.conInfo.certificatetype === "0" && res === true) {
                let y = this.conInfo.certificateno.substr(6, 4);
                let m = this.conInfo.certificateno.substr(10, 2);
                let d = this.conInfo.certificateno.substr(12, 2);

                this.$set(this.birthSet,"val",`${y}-${m}-${d}`);
                this.conInfo.investorsbirthday = `${y}-${m}-${d}`;
                this.conInfo.investorsbirthday = this.birthSet.val !== null ? this.birthSet.val.replace(/-/g, "") : "";
            }
        },
        validateCertNo (value, certType, dateRange, callback) {
            if (certType === "0") {
                let y = value.substr(6, 4);
                let m = value.substr(10, 2);
                let d = value.substr(12, 2);
                if(new Date(`${y}-${m}-${d}`).getTime() < new Date(dateRange[0]).getTime() || new Date(`${y}-${m}-${d}`).getTime() > new Date(dateRange[1]).getTime()){
                    callback(new Error("请输入适龄的身份证号"));
                    return false;
                }
                callback();
                return true;
            } else {
                callback();
                return false;
            }
        },
        dateBirth (val) {
            this.conInfo.investorsbirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        validateAddress (rule, value, callback) {
            if(this.isChina&&value.trim() == ""){
                callback(new Error("请输入现居地址"));
                return
            }
            if (this.isChina || value.trim() !== "") {
                this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.checkconInfo.pwd = _this.conInfo.pwd;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    if(JSON.stringify(_this.checkconInfo) == JSON.stringify(_this.conInfo)) {
                        _this.$message({
                            type: "info",
                            message: "表单数据未改变，请勿重复提交"
                        });
                        return;
                    }
                    const way = (_this.lock ) ? "POST" : "PUT";
                    if (_this.conInfo.taxestype === "1") {
                        _this.conInfo.taxesplace = "CN";
                    }
                    const _x = Object.assign({}, _this.conInfo);
                    delete _x.protocol;
                    _x.tradepwd = _this.$util.enc(_x.pwd);
                    delete _x.pwd;
                    _this.$util.request("tax/OrgControlInfo", _x, way).then(res => {
                        const msg = way === "PUT" ? "修改" : "新增";
                        if (res.data) {
                            const info = _this.$cache.getUser();
                            _this.$store.dispatch("setInfo", info).then(() => {
                                _this.$message({
                                    type: "success",
                                    message: msg + "控制人信息成功" + (_this.fn ? "" : "，3秒后回到控制人列表"),
                                    onClose: function () {
                                        if (_this.fn) { _this.$emit("fn-back", true); } else {
                                            // eslint-disable-next-line standard/object-curly-even-spacing
                                            _this.$router.push({ "name": "controllist" , "query": {"taxesflag": _this.$route.query.taxesflag}});
                                        }
                                    }
                                });
                            });
                        } else {
                            _this.$message({
                                type: "warning",
                                message: res.msg
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        getconInfo (_x) {
            const _this = this;
            this.$util.request("tax/OrgControlInfo", _x).then(res => {
                let info = res.data.filter(item => {
                    return item.taxiesinfoid == _x.taxiesinfoid;
                });
                for (let item in info[0]) {
                    info[0][item] = info[0][item].trim();
                }
                _this.conInfo = Object.assign({}, _this.conInfo, info[0] || {});
                if (_this.conInfo.taxesno) {
                    _this.conInfo.tHaveTaxID = "1";
                } else if (_this.conInfo.notaxesreason) {
                    _this.conInfo.tHaveTaxID = "0";
                }
                _this.taxestypeOld = _this.conInfo.taxestype;
            });
        },
        getCity (val) {
            const _this = this;
            this.$util.request("common/citylist", { provinceid: val }).then(res => {
                _this.currentcity = res.data;
            });
        },
        getCounty (val) {
            const _this = this;
            this.$util.request("common/countylist", { cityid: val }).then(res => {
                _this.county = res.data;
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-con-info {
    .el-col.el-col-12 {
        height: 51px;
        overflow: hidden;
    }
    .taxes-box {
        padding: 30px 30px 45px;
        .box-card {
            margin-bottom: 20px;
            .clearfix {
                font-size: $f16;
                color: $color-a
            }
        }
        .mes-col {
            margin-bottom: 10px;
            &.last {
                margin-bottom: 0;
            }
            .cut-off-line {
                margin: 30px 0 0;
                top: -30px;
                font-size: $f16;
            }
            &.bg {
                background-color: $bg5;
                .cut-off-line {
                    border-color: $border-color9;
                    span {
                        color: $color-b;
                    }
                }
            }
        }
    }
}
</style>
